import { render, staticRenderFns } from "./PointBack.vue?vue&type=template&id=73248c30&scoped=true"
import script from "./PointBack.vue?vue&type=script&lang=js"
export * from "./PointBack.vue?vue&type=script&lang=js"
import style0 from "./PointBack.vue?vue&type=style&index=0&id=73248c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73248c30",
  null
  
)

export default component.exports